// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2Ap2l"};